import { Content } from '@radix-ui/react-accordion'
import React from 'react'

import { styled } from '~/styled'
import { CSSWrapper } from '~/utilities/css-wrapper/CSSWrapper'

const StyledContent = styled(Content, {
  base: [
    'border-none',
    'w-full',
    'bg-(--base-1)',
    'overflow-hidden',
    'data-[state=open]:rounded-b-sm',
    'data-[state=open]:rounded-t-none',
    'motion-safe:data-[state=open]:animate-accordion-open',
    'motion-safe:data-[state=closed]:animate-accordion-close'
  ]
})

export const AccordionContent = ({
  children,
  className,
  ...remainingProps
}: React.ComponentProps<typeof StyledContent>) => (
  <StyledContent {...remainingProps}>
    <CSSWrapper className={className}>{children}</CSSWrapper>
  </StyledContent>
)
